<template>
  <textarea
    :id="id"
    ref="textarea"
    :value="modelValue"
    :title="title"
    :placeholder="placeholder"
    :name="name"
    class="form-control f-14"
    :class="additionalClasses"
    @input="$emit('update:modelValue', $event.target.value)"
    @focus="focus"
  />
</template>

<script>
import { nextTick } from 'vue'

export default {
  props: {
    modelValue: { type: String, default: '' },
    id: { type: String, default: '' },
    name: { type: String, required: true },
    additionalClasses: { type: String, default: '' },
    title: { type: String, default: '' },
    placeholder: { type: String, default: '' },
  },
  emits: ['update:modelValue'],
  mounted() {
    nextTick(() => {
      this.$refs.textarea.setAttribute(
        'style',
        `height:${this.$refs.textarea.scrollHeight}px;overflow-y:hidden;`,
      )
    })
    this.$refs.textarea.addEventListener('input', this.resizeTextarea)
  },
  beforeUnmount() {
    this.$refs.textarea.removeEventListener('input', this.resizeTextarea)
  },
  methods: {
    focus() {
      nextTick(() => {
        this.$refs.textarea.focus?.()
        this.resizeTextarea()
      })
    },
    resizeTextarea() {
      this.$refs.textarea.style.height = `${this.$refs.textarea.scrollHeight}px`
    },
  },
}
</script>
